<swiper [config]="sliderConfig">
  <ng-template swiperSlide *ngFor="let photo of this.photos; index as i">
  <img
      [attr.data-src]="useThumb ? photo.thumb_url : photo.original_url"
      [alt]="'Photo ' + (i + 1) + ' of ' + alt"
      class="swiper-image swiper-lazy"
      [ngClass]="{ 'expandable' : isExpandable }"
      [style.height]="imageHeight? imageHeight + 'px' : null"
    />
    <button class="help-text-overlay" *ngIf="isExpandable" (click)="expandThisPhoto($event)" [attr.data-index]="i">
      <span>Click photo to expand</span>
    </button>
    <div class="swiper-lazy-preloader"></div>
  </ng-template>
  <div class="swiper-pagination"></div>
</swiper>
<fa title="previous" class="custom-navigation-button custom-navigation-button-prev navigation-prev-{{swiperIndex}}" name="chevron-circle-left"></fa>
<fa title="next" class="custom-navigation-button custom-navigation-button-next navigation-next-{{swiperIndex}}" name="chevron-circle-right"></fa>
